import { useLocation } from 'react-router-dom';

export default function OrganizationHelpPage() {
    const location = useLocation();
    const isSidebarOpen = location?.state?.isSidebarOpen;

    return (
        <div className={`p-6 md:p-10 overflow-auto ${isSidebarOpen ? 'md:ml-64' : 'md:ml-0'}`}>
            <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Organization Help & Support</h1>
            <p className="mt-1 text-gray-500 dark:text-gray-400">Resources and support for organizations.</p>
            
            <div className="mt-6 bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6 space-y-6">
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">How does the organization campaign process work?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">Organizations can request multiple devices for their beneficiaries. Each request goes through a verification process to ensure legitimacy and need.</p>
                </div>
                
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">What documentation is required for organizations?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">We require valid registration documents (CAC certificate, trust deed, incorporation certificate, or other legal documents) to verify your organization's legitimacy.</p>
                </div>
                
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">How do we collect items for our beneficiaries?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">Once items are funded, an authorized representative must come to our designated center with original identification and organization documentation to collect the items.</p>
                </div>
                
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">Can we request multiple items?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">Yes, organizations can request multiple items for different beneficiaries. Each request is treated as a separate campaign.</p>
                </div>
                
                <div>
                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-200">Need more help?</h3>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">For organization-specific inquiries, contact our partnerships team at <a href="mailto:partnerships@givetechtotheblind.com" className="text-orange-600 hover:underline">partnerships@givetechtotheblind.com</a>.</p>
                </div>
            </div>
        </div>
    );
}